module.exports = __webpack_public_path__ + "img/grey-setting.f257fb19.svg";